import LikeIcon from "../ui/icons/LikeIcon";
import UnLikeIcon from "../ui/icons/UnLikeIcon";
import RefreshIcon from "../ui/icons/RefreshIcon";
import CopyIcon from "../ui/icons/CopyIcon";
import { useLocation } from "react-router-dom";

const MessageActions = ({
  onCopyClick,
  onRefreshClick,
  onLikeClick,
  onUnlikeClick,
}: {
  onCopyClick: () => void;
  onRefreshClick: () => void;
  onLikeClick: () => void;
  onUnlikeClick: () => void;
}) => {
  const isShared = useLocation().pathname.includes("share");
  return (
    <div className="flex">
      <button
        className="w-[40px] h-[40px] flex items-center justify-center"
        onClick={onCopyClick}
      >
        <CopyIcon />
      </button>
      {!isShared && (
        <button
          className="w-[40px] h-[40px] flex items-center justify-center"
          onClick={onRefreshClick}
        >
          <RefreshIcon />
        </button>
      )}
      {!isShared && (
        <button
          className="w-[40px] h-[40px] flex items-center justify-center"
          onClick={onLikeClick}
        >
          <LikeIcon />
        </button>
      )}
      {!isShared && (
        <button
          className="w-[40px] h-[40px] flex items-center justify-center"
          onClick={onUnlikeClick}
        >
          <UnLikeIcon />
        </button>
      )}
    </div>
  );
};

export default MessageActions;
